export const SET_IS_LOADING = 'SUPPLIER_LIST/SET_IS_LOADING';
export const SET_SUPPLIER_LIST = 'SUPPLIER_LIST/SET_SUPPLIER_LIST';